/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import SqcOutletDisplay from 'equipmentComponents/SqcOutletDisplay';
import OutletMenu from 'equipmentComponents/OutletMenu';
import { green500, red500 } from 'material-ui/styles/colors';
import FontIcon from 'material-ui/FontIcon';
import TextFormatter from 'utils/TextFormatter';
import EquipmentUtils from '../../utils/EquipmentUtils';
import { textUtils } from '../../utils/textUtils';

class Outlet extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.handleExpandChange = this
            .handleExpandChange
            .bind(this);
    }

    handleExpandChange(expanded) {
        const { orderId, workOrderActions, outlet } = this.props;
        workOrderActions.setOutletExpanded(expanded, orderId, outlet.get('equipmentOutlet'));
    }

    render() {
        const {
            outlet,
            sqcActions,
            sqcResults,
            orderId,
            workOrderActions,
            techInventory,
            loading,
            billingSystem,
            equipmentHitDetails,
            refreshHitDetails,
            hasWHWF,
            equipmentValidations,
            customerDetails,
            houseEquipmentDetails,
            equipmentDetails
        } = this.props;

        if (!outlet) {
            return null;

        }
        const getStatusStyle = (statusString) => {
            let statusStyle = '';

            switch (statusString) {
                case 'Add':
                    statusStyle = { color: 'green' };
                    break;

                case 'Remove':
                    statusStyle = { color: 'red' };
                    break;

                case 'Current':
                    statusStyle = { color: 'black' };
                    break;

                default:
                    statusStyle = { color: 'black' };
            }

            return (
                statusStyle
            );
        };

        const reducedPaddingStyle = {
            paddingTop: '5px',
            paddingBottom: '5px'
        };

        const serviceRows = outlet
            .get('serviceCodeList').sortBy(item => item.get('status'))
            .map((serviceCodeItem, serviceCodeItemIndex) => {
                return (
                    <tr key={`equip_row_${serviceCodeItemIndex}`}>
                        <td>{serviceCodeItem.get('code')}</td>
                        <td>{serviceCodeItem.get('description')}</td>
                        <td style={getStatusStyle(serviceCodeItem.get('status'))}>{serviceCodeItem.get('status')}</td>
                    </tr>
                );
            });

        const serviceTable = (
            <table className="bordered striped">
                <tbody>{serviceRows}</tbody>
            </table>
        );



        let model = '';

        if (outlet.get('model')) {
            model = ' - ' + outlet.get('model');
        }

        let headerText = `${outlet.get('make') || outlet
            .get('requiredPortType')
            .join(',')}${model}`;

        let hitMessage = null,
            customerOwnedModemMessage = null,
            hitMessageColor = green500;

        if (EquipmentUtils.isCustomerOwnedModem(outlet)) {
            headerText = textUtils.equipment.customerOwnedModem.header;
            customerOwnedModemMessage = (<p className="failure-msg-color">
                {textUtils.equipment.customerOwnedModem.message}
            </p>);
        }

        if (EquipmentUtils.isModemInternet1200Type(outlet)) {
            if (!outlet.get("status") === "Remove") {
                headerText = hasWHWF || !outlet.get("macAddress")
                    ? headerText
                    : textUtils.equipment.internet1200Modem.standalone;
            }
        }

        if (outlet.get('hitIsSuccess') === false) {
            hitMessageColor = red500;
        }

        if (outlet.get('hitMessage')) {
            hitMessage = (
                <p style={{
                    color: hitMessageColor
                }}>{outlet.get('hitMessage')}</p>
            );
        }

        if (outlet.get('hitStarted')) {
            hitMessage = (
                <p style={{
                    color: green500
                }}>Sending Request...</p>
            );
        }

        if (outlet.get('hitError')) {
            hitMessage = (
                <p style={{
                    color: red500
                }}>{outlet.get('hitError')}</p>
            );
        }

        const actionRequired = outlet.get('actionRequired');
        const hasDisableAddsAndSwap = outlet.get('disableAddsAndSwaps');
        let actionIcon = null;
        const actionIconStyles = {
            marginTop: 1,
        };

        if (actionRequired) {
            actionIcon = (
                <FontIcon color={red500} style={actionIconStyles} className="material-icons">warning</FontIcon>
            );
        }

        if (actionRequired && !hasDisableAddsAndSwap) {
            actionIcon = null;
        }

        let phoneNumberDisplay = null;
        if (outlet.get('billingMappings')) {
            const billingMappings = outlet.get('billingMappings');

            billingMappings.forEach((item) => {
                const billingProductCode = item.get('billingProductCode');
                if (item.get('serviceNumber') && billingProductCode && (billingProductCode === 'P' || billingProductCode === 'T')) {
                    const phoneNumberFormatted = TextFormatter.formatPhoneNumber(item.get('serviceNumber').replace('[Pending] ', ''));
                    phoneNumberDisplay = (
                        <h5>{phoneNumberFormatted}</h5>
                    );
                }
            });

        }

        return (
            <div>
                <Card
                    expanded={outlet.get('isExpanded')}
                    onExpandChange={this.handleExpandChange}
                    style={{
                        marginBottom: '8px'
                    }}
                >
                    <CardHeader
                        avatar={actionIcon}
                        style={reducedPaddingStyle}
                        title={headerText}
                        actAsExpander={true}
                        showExpandableButton={true}
                    />
                    <CardText style={reducedPaddingStyle}>
                        {phoneNumberDisplay}
                        <OutletMenu
                            loading={loading}
                            outlet={outlet}
                            workOrderActions={workOrderActions}
                            orderId={orderId}
                            techInventory={techInventory}
                            billingSystem={billingSystem}
                            equipmentHitDetails={equipmentHitDetails}
                            refreshHitDetails={refreshHitDetails}
                            equipmentValidations={equipmentValidations}
                            customerDetails={customerDetails}
                            houseEquipmentDetails={houseEquipmentDetails}
                            equipmentDetails={equipmentDetails}
                        />
                        {hitMessage}
                        {customerOwnedModemMessage}
                    </CardText>
                    <CardText expandable={true} style={reducedPaddingStyle}>
                        <SqcOutletDisplay
                            sqcActions={sqcActions}
                            sqcResults={sqcResults}
                            orderId={orderId}
                            outlet={outlet}
                        />
                    </CardText>
                    <CardText expandable={true} style={reducedPaddingStyle}>
                        <label>Mac:
                        </label>
                        {outlet.get('macAddress')}
                        {serviceTable}
                    </CardText>
                </Card>
            </div>
        );
    }
}

Outlet.propTypes = {
    outlet: PropTypes.object,
    sqcResults: PropTypes.object,
    orderId: PropTypes.string,
    techInventory: PropTypes.object,
    workOrderActions: PropTypes.object,
    sqcActions: PropTypes.object,
    loading: PropTypes.bool,
    billingSystem: PropTypes.string,
    isSkinnyInstallType: PropTypes.bool
};
export default Outlet;



// WEBPACK FOOTER //
// ./src/components/equipment/Outlet.js